import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import cx from "classnames";
import { populateFormDetails } from '../../Common/Appcommon';
import { dashboardSortList } from './Constants';

const GraphConfigForm = (props) => {
    let { control, errors, preFormData, preFormDetail, preFormList, preSummaryList, preSelectedSummary, preSelectedForm, onSearchClickRegister, onFormChange,
        preField, preSortBy, preFieldList
     } = props;
    let [selectedForm, setSelectedForm] = useState(preSelectedForm);
    let [formData, setFormData] = useState(preFormData);
    let [selectedMetrics, setSelectedMetrics] = useState(preSelectedSummary);
    let [formList, setFormList] = useState(preFormList);
    let [formDetail, setFormDetail] = useState(preFormDetail);
    let [summaryFields, setSummaryFields] = useState([]);
    let [fieldList, setFieldList] = useState([]);
    let [selectedField, setSelectedField] = useState([]);
    let [sortBy, setSortBy] = useState({});

    useEffect(() => {
        onSearchClickRegister(processSearchCallBacks);
    });

    const processSearchCallBacks = async (operation, customProps = {}) => {
        let saveFormData = {};
        saveFormData = formData;
        saveFormData['form'] = selectedForm;
        saveFormData['metric'] = selectedMetrics;
        saveFormData['field'] = selectedField;
        saveFormData['sort'] = sortBy;
        return saveFormData;
    }

    useEffect(() => {
        setFormData(preFormData);
    }, [preFormData]);

    useEffect(() => {
        setSelectedForm(preSelectedForm);
    }, [preSelectedForm]);

    useEffect(() => {
        setSelectedMetrics(preSelectedSummary);
    }, [preSelectedSummary]);

    useEffect(() => {
        setFormList(preFormList);
    }, [preFormList]);

    useEffect(() => {
        setSummaryFields(preSummaryList);
    }, [preSummaryList]);

    useEffect(() => {
        for(let i = 0; i < dashboardSortList.length; i++){
            let sort = dashboardSortList[i];
            if(sort.value === preSortBy){
                setSortBy(sort);
                break;
            }
        }
    }, [preSortBy]);

    useEffect(() => {
        setSelectedField(preField);
    }, [preField]);

    useEffect(() => {
        setFieldList(preFieldList);
    }, [preFieldList]);

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleTemplateChange = async (selectedValue, objName) => {
        if (objName === "selected_form") {
            setSelectedForm(selectedValue);
            setFormDetail([]);
            let details = await populateFormDetails(selectedValue.value);
            setFormDetail(details);
            await constructSummaryFieldList(details);
            await constructFieldList(details);
            await onFormChange(details);
        } else if (objName === "metric") {
            setSelectedMetrics(selectedValue);
        } else if (objName === "group_field"){
            setSelectedField(selectedValue);
        } else if (objName === "sort_by") {
            setSortBy(selectedValue);
        }
    }

    const constructSummaryFieldList = async (details, defaultSummary = "") => {
        let fieldDetails = details[1];
        let summaryList = [];
        summaryList.push({ value: "Record_Count", label: "Record Count" })
        let defaultSum = summaryList[0];
        fieldDetails.map((field, index) => {
            let fieldType = field[4];
            let fieldName = field[2];
            let fieldLabel = field[3];
            if (fieldType === "Currency") {
                let listvalue = { value: fieldName, label: "Sum of " + fieldLabel };
                if (fieldName === defaultSummary) {
                    defaultSum = listvalue;
                }
                summaryList.push(listvalue)
            }
        });
        setSelectedMetrics(defaultSum);
        setSummaryFields(summaryList);
    }


    const constructFieldList = async(details, defaultField) => {
        let fieldDetails = details[1];
        let flist = [];
        let dfield = {};
        fieldDetails.map((field, index) => {
            let fieldType = field[4];
            let fieldName = field[2];
            let fieldLabel = field[3];
            if (fieldType !== "reference_entityid" && fieldType !== "reference_group" && fieldType !== "form_history" && fieldType !== "form_entityid" && fieldType !== "Date_Time" && fieldType !== "Date_Time_Text" && fieldType !== "subtable" && fieldType !== "Currency" && fieldType !== "Text Area") {
                let listvalue = { value: fieldName, label: fieldLabel };
                if (fieldName === defaultField) {
                    dfield = listvalue;
                }
                flist.push(listvalue)
            }
        });
        setSelectedField(dfield);
        setFieldList(flist);
    }


    return (
        <Fragment>
            <div className='input-section'>
                <label className={'workflow-lbl form-label'} htmlFor="db_name">Component Name</label>
                <Controller
                    name="db_name"
                    control={control}
                    rules={{ required: formData.db_name === undefined || formData.db_name === "" ? "Please provide component name" : false }}
                    render={({ field }) => {
                        return (
                            <input
                                {...field}
                                type="text"
                                name="db_name"
                                id="db_name"
                                value={formData.db_name}
                                autoComplete={"off"}
                                onChange={(e) => {
                                    field.onChange(e);
                                    onInputChange(e);
                                }}
                                className={`form-control ${errors.db_name ? 'is-invalid' : ''}`}
                            />
                        );
                    }}
                />
                {errors.db_name && <em className={`error invalid-feedback`}>{errors.db_name.message}</em>}
            </div>
            <div className={cx('input-section mt-3')}>
                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="selected_form">Choose a Module</label>
                <Controller
                    name="selected_form"
                    control={control}
                    rules={{ required: Object.keys(selectedForm).length === 0 ? "Please choose a module" : false }}
                    render={({ field }) => {
                        return (
                            <Select
                                {...field}
                                placeholder={'---Choose One---'}
                                menuPlacement={"auto"}
                                menuPosition={'fixed'}
                                name="selected_form"
                                id="selected_form"
                                className={`basic-multi-select ${errors.selected_form ? 'is-invalid' : ''}`}
                                classNamePrefix="wa-select"
                                value={Object.keys(formList).length === 0 ? false : selectedForm}
                                onChange={e => {
                                    handleTemplateChange(e, 'selected_form');
                                    field.onChange(e);
                                }}
                                options={formList}
                            />
                        );
                    }}
                />
                {errors.selected_form && <em className={`error invalid-feedback`}>{errors.selected_form.message}</em>}

            </div>
            <div className={cx('input-section mt-3')}>
                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="group_field">Column</label>
                <Controller
                    name="group_field"
                    control={control}
                    rules={{ required: Object.keys(selectedMetrics).length === 0 ? "Please choose a column" : false }}
                    render={({ field }) => {
                        return (
                            <Select
                                {...field}
                                placeholder={'---Choose One---'}
                                menuPlacement={"auto"}
                                menuPosition={'fixed'}
                                name="group_field"
                                id="group_field"
                                className={`basic-multi-select ${errors.group_field ? 'is-invalid' : ''}`}
                                classNamePrefix="wa-select"
                                value={selectedField}
                                onChange={e => {
                                    handleTemplateChange(e, 'group_field');
                                    field.onChange(e);
                                }}
                                options={fieldList}
                            />
                        );
                    }}
                />
                {errors.group_field && <em className={`error invalid-feedback`}>{errors.group_field.message}</em>}

            </div>
            <div className={cx('input-section mt-3')}>
                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="metric">Summary By</label>
                <Controller
                    name="metric"
                    control={control}
                    rules={{ required: Object.keys(selectedMetrics).length === 0 ? "Please choose a summary field" : false }}
                    render={({ field }) => {
                        return (
                            <Select
                                {...field}
                                placeholder={'---Choose One---'}
                                menuPlacement={"auto"}
                                menuPosition={'fixed'}
                                name="metric"
                                id="metric"
                                className={`basic-multi-select ${errors.metric ? 'is-invalid' : ''}`}
                                classNamePrefix="wa-select"
                                value={Object.keys(summaryFields).length === 0 ? false : selectedMetrics}
                                onChange={e => {
                                    handleTemplateChange(e, 'metric');
                                    field.onChange(e);
                                }}
                                options={summaryFields}
                            />
                        );
                    }}
                />
                {errors.metric && <em className={`error invalid-feedback`}>{errors.metric.message}</em>}

            </div>
            <div className={cx('input-section mt-3')}>
                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="sort_by">Sort By</label>
                <Controller
                    name="sort_by"
                    control={control}
                    rules={{ required: false }}
                    render={({ field }) => {
                        return (
                            <Select
                                {...field}
                                placeholder={'---Choose One---'}
                                menuPlacement={"auto"}
                                menuPosition={'fixed'}
                                name="sort_by"
                                id="sort_by"
                                className={`basic-multi-select ${errors.sort_by ? 'is-invalid' : ''}`}
                                classNamePrefix="wa-select"
                                value={Object.keys(sortBy).length === 0 ? dashboardSortList[0] : sortBy}
                                onChange={e => {
                                    handleTemplateChange(e, 'sort_by');
                                    field.onChange(e);
                                }}
                                options={dashboardSortList}
                            />
                        );
                    }}
                />
                {errors.sort_by && <em className={`error invalid-feedback`}>{errors.sort_by.message}</em>}

            </div>
        </Fragment>
    );
}

export default React.memo(GraphConfigForm);